export const SERVICE_CODE = 'DEAL_TAGS' + '_SERVICE';
